import React from "react";
import "../../Style/Header.css";

const Header = () => {
  return (
    <div className="container-xxl p-0">
      <div className="header_banner_content justify-content-center align-items-center "></div>
    </div>
  );
};

export default Header;
